import axios from 'axios';
import { ContactUsModel, ContactUsResponse, GuidesListResponse, Page } from './types';
import { SearchRuToursModel } from './ts/classes/SearchRuToursModel';
import { Select } from '@bepro-travel/fe.ui';
import { OphirResultsResponse } from './ts/interfaces/OphirResponse';
import { OphirBookResponse } from './ts/interfaces/OphirBook';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
// import { Screenshot } from '@bepro-travel/fe.utils';

interface GetMonthsParams {
  countryCode?: string;
  selectAll?: boolean;
}

export const getMonths = async (params: GetMonthsParams): Promise<Select[] | undefined> => {
  try {
    const lang = localStorage.getItem('language') || 'he';
    const url = 'Tours/GetMonths';

    const data = (await axios.post(url, { ...params, language: lang })).data.monthes.map(
      (month: any) => ({
        value: month.date,
        label: month.name,
      }),
    );

    return [{ value: 'all', label: 'tour.choose_date' }, ...data];
  } catch (err) {
    return [];
  }
};

export const getCountries = async (): Promise<any[] | undefined> => {
  const storedCountries = sessionStorage.getItem('ophCountries');
  if (storedCountries) {
    return JSON.parse(storedCountries);
  }

  try {
    const lang = localStorage.getItem('language') || 'he';
    const url = 'Tours/GetCountries';
    const data = (await axios.post(url, { language: lang })).data.countries.map((month: any) => ({
      value: month.code,
      label: month.name,
    }));
    const result = [{ value: 'all', label: 'tour.choose_country' }, ...data];

    sessionStorage.setItem('ophCountries', JSON.stringify(result));
    return result;
  } catch (err) {
    return [];
  }
};

export const search = async (
  params: SearchRuToursModel,
): Promise<OphirResultsResponse | undefined> => {
  try {
    const lang = localStorage.getItem('language') || 'he';
    const url = lang === 'he' ? 'Tours/SearchTours' : 'Tours/SearchRuTours';
    return (await axios.post(url, params)).data;
  } catch (err) {
    return undefined;
  }
};

export interface GetDetailsParams {
  checkIn: string;
  dealId: string;
  hotelName: string;
  nights: number;
  packageId: string;
  room?: string;
  recaptchaToken: string;
  cityCode: string;
  rooms?: string;
  isSale?: boolean;
}

export const getDetails = async (params: GetDetailsParams): Promise<any | void> => {
  try {
    const lang = localStorage.getItem('language') || 'he';
    const url = lang === 'he' ? 'Tours/details' : 'Tours/detailsru';
    return (await axios.post(url, { ...params, language: lang })).data;
  } catch (err) {}
};

export const getBookDetails = async (
  params: GetDetailsParams,
): Promise<OphirBookResponse | void> => {
  try {
    const lang = localStorage.getItem('language') || 'he';
    const url = lang === 'he' ? 'Tours/ApiBook' : 'Tours/ApiBookRu';
    return (await axios.post(url, { ...params, language: lang })).data;
  } catch (err) {}
};

export const bookComplete = async (params: any): Promise<any | void> => {
  try {
    // const screenshotsJson = sessionStorage.getItem('screenshotsOphir');
    // let screenshots: string[] = [];
    // if (screenshotsJson) {
    //   const screenshotsArr: Screenshot[] = JSON.parse(screenshotsJson);
    //   screenshots = screenshotsArr.map((screenShots) => screenShots.data);
    // }

    const lang = localStorage.getItem('language') || 'he';
    const url = lang === 'he' ? '/Tours/ApiBookComplete' : '/Tours/ApiBookCompleteRu';
    return (await axios.post(url, { ...params, language: lang })).data;
  } catch (err) {}
};

// export const submitScreenshots = async (params: SubmitScreenshotsParams): Promise<any> => {
//   try {
//     const url = 'Tours/SubmitScreenshots';

//     return (await axios.post(url, params)).data;
//   } catch (err) {
//     return undefined;
//   }
// };

export const checkPaymentStatus = async (transactionId: string): Promise<any | undefined> => {
  try {
    const url = 'Tours/CheckPaymentStatus';

    return (await axios.post(url, { transactionId })).data;
  } catch (err) {
    return undefined;
  }
};

export const sendContactUs = async (
  data: ContactUsModel,
): Promise<ContactUsResponse | undefined> => {
  try {
    const url = 'Utils/ContactUs';
    return (await axios.post(url, data)).data;
  } catch (err) {
    return undefined;
  }
};

export const getGuidesList = async (): Promise<Page[] | undefined> => {
  try {
    const url = 'data/GuidesListRu';
    const data = (await axios.post(url, {})).data as GuidesListResponse & {
      GuidePages?: Page[];
    };
    return data.guidePages || data.GuidePages || [];
  } catch (err) {
    return undefined;
  }
};

export const generateItineraryHtml = async (printHtml: string, id: number): Promise<void> => {
  try {
    const url = 'Tours/DownloadItineraryHtml';
    const response = await axios.post(url, { printHtml, id }, { responseType: 'blob' });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `itinerary-${id}.pdf`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    // ignore
  }
};

export const getLocaleSet = (locale?: string) => {
  return ru;
};

export const dateFormat = (
  date: Date | string | undefined | number,
  formatStr: string,
  locale?: string,
) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const localeSet = getLocaleSet(locale);
  if (dateObj instanceof Date && isNaN(dateObj.getTime())) return '';

  return format(dateObj || new Date(), formatStr, { locale: localeSet });
};
